<!-- Top Bar -->
<sbi-cot-back-main-top-bar></sbi-cot-back-main-top-bar>

<!-- Page Container -->
<div class="private-page-container">
  <div class="content">
    <form [formGroup]="dashboardForm">
      <!-- Insurance Validity -->
      <div class="sub-section last">
        <h4>Gráfico de estadísticas de pólizas</h4>
        <div class="inputs-container pb-4 d-flex">
          <!-- Fecha de inicio -->
          <div class="d-flex">
            <div
              class="input-container date-picker mr-4"
              [class.error]="isTouchedAndInvalid('dateFrom')"
            >
              <span class="label">Fecha desde</span>
              <div class="input">
                <input
                  name="text-4"
                  type="text"
                  [max]="maxAvailableDate"
                  [min]="minAvailableDate"
                  (click)="datePickerFrom.open()"
                  placeholder="Fecha desde"
                  autocomplete="off"
                  app-autocomplete
                  [matDatepicker]="datePickerFrom"
                  formControlName="dateFrom"
                />

                <i
                  (click)="datePickerFrom.open()"
                  class="fas fa-calendar-alt"
                ></i>
              </div>
              <ng-container *ngIf="isTouchedAndInvalid('dateFrom')">
                <span
                  *ngIf="
                    getFormControl('dateFrom').hasError('required') &&
                    !getFormControl('dateFrom').hasError('matDatepickerParse')
                  "
                  class="status-message"
                  >Debe ingresar una fecha</span
                >
                <span
                  *ngIf="
                    getFormControl('dateFrom').hasError('matDatepickerMin') ||
                    getFormControl('dateFrom').hasError('matDatepickerParse')
                  "
                  class="status-message"
                  >Fecha inválida</span
                >
              </ng-container>
            </div>
          </div>
          <!-- Fecha fin -->
          <div class="d-flex">
            <div
              class="input-container date-picker mr-4"
              [class.error]="isTouchedAndInvalid('dateTo')"
            >
              <span class="label">Fecha hasta</span>
              <div class="input">
                <input
                  name="text-4"
                  type="text"
                  [max]="maxAvailableDate"
                  [min]="minAvailableDate"
                  (click)="datePickerTo.open()"
                  placeholder="Fecha hasta"
                  autocomplete="off"
                  app-autocomplete
                  [matDatepicker]="datePickerTo"
                  formControlName="dateTo"
                />

                <i
                  (click)="datePickerTo.open()"
                  class="fas fa-calendar-alt"
                ></i>
              </div>
              <ng-container *ngIf="isTouchedAndInvalid('dateTo')">
                <span
                  *ngIf="
                    getFormControl('dateTo').hasError('required') &&
                    !getFormControl('dateTo').hasError('matDatepickerParse')
                  "
                  class="status-message"
                  >Debe ingresar una fecha</span
                >
                <span
                  *ngIf="
                    getFormControl('dateTo').hasError('matDatepickerMax') ||
                    getFormControl('dateTo').hasError('matDatepickerParse')
                  "
                  class="status-message"
                  >Fecha inválida</span
                >
              </ng-container>
            </div>

            <!-- Datepicker -->
            <mat-datepicker #datePickerFrom></mat-datepicker>
            <mat-datepicker #datePickerTo></mat-datepicker>
          </div>
          <button
            (click)="onChartsRequest()"
            class="button button-blue"
            [class.loading]="loading$ | async"
            [disabled]="
              dashboardForm.disabled ||
              !dashboardForm.dirty ||
              (loading$ | async)
            "
          >
            <i class="fas fa-search"></i>
            Filtrar
          </button>
        </div>
      </div>
    </form>

    <div *ngIf="dashboardStatistics$ | async">
      <sbi-cot-back-charts-component
        [xAxisName]="'Fecha'"
        [yAxisName]="'Cantidad de pólizas'"
      ></sbi-cot-back-charts-component>
    </div>
  </div>
</div>
